import styled from "styled-components";

export const GameContainer = styled.div`
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
background-color: var(--theme-primary);
width: 100%;
min-height: 100vh;
`